export default "icon-team.svg"